
import { SamplingPoint } from "@/types/samplingpoint.type";
import { defineComponent, ref } from "vue";

import { Container } from "@/types/container.type";
import SamplingPointImageComponent from "./SamplingPointImage.component.vue";
import { SearchSamplingPoint } from "@/types";

import SamplingPointSearchFormComponent from "./SamplingPointSearchForm.component.vue";
import NoDataComponent from "@/components/NoData.component.vue";
import securityService from "@/service/security.service";
import { AppRole } from "@/types/app.type";
import { Estimations } from "@/types/estimation.type";

interface DataItem {
  index: string;
  title: string;
}
export default defineComponent({
  props: {
    samplingPointFirst: {
      type: Object as () => SamplingPoint[],
      required: true,
      immediate: true,
      deep: true,
    },
    containerId: {
      type: Number,
    },
    detailRouterName: {
      type: String,
    },
    onClick: {
      type: Function,
      required: false,
    },
    refresh: {
      type: Function,
      required: true,
    },
    showButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    SamplingPointImageComponent,
    SamplingPointSearchFormComponent,
    NoDataComponent,
    //Loading,
  },
  setup() {
    const items: DataItem[] = [
      {
        index: "code",
        title: "label.code",
      },
      {
        index: "receivingMedium",
        title: "label.river",
      },
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const samplingPointSearchForm = ref<any>();
    const isAppDemo = securityService.hasRole(AppRole.DEMOS) ? true : false;

    return {
      items,
      samplingPointSearchForm,
      isAppDemo,
    };
  },
  data() {
    return {
      samplingPoints: [] as SamplingPoint[],
      containers: [] as Container[],

      isModalImageVisible: false,
      samplingPointId: "",

      query: "" as string,
      search: undefined as SearchSamplingPoint | undefined,
      lastImage: undefined as Estimations | undefined,
      loading: true,
    };
  },
  async mounted() {
    this.samplingPoints = this.samplingPointFirst;
  },

  methods: {
    closeModalImage() {
      this.samplingPointId = "";
      this.isModalImageVisible = false;
    },

    seeDetail(samplingPoint: SamplingPoint) {
      if (!this.$route.path.includes("samplingPoints/samplingPoints")) {
        this.$router.push(`/samplingPoints/samplingPoints/${samplingPoint.name}`);
      } else {
        this.$router.push(`samplingPoints/${samplingPoint.name}`);
      }
    },
    openSamplingPointDetail(samplingPoint: SamplingPoint) {
      const container = samplingPoint.container as Container | undefined;
      if (
        container?.id &&
        this.$route.path.includes("support") &&
        !this.$route.path.includes("samplingPoints/")
      ) {
        if (this.$route.path.includes("samplingPoints")) {
          this.$router.push(
            "samplingPoints/" + container?.id + "?samplingPoint=" + samplingPoint.id
          );
        } else {
          this.$router.push(
            "/support/samplingPoints/" + container?.id + "?samplingPoint=" + samplingPoint.id
          );
        }
      } else if (container?.id && this.detailRouterName) {
        this.$router.push({
          name: this.detailRouterName,
          params: { containerid: container.id },
        });
      } else if (this.onClick !== undefined) {
        this.onClick(samplingPoint);
      }
    },
    doSearch(search: SearchSamplingPoint | undefined) {
      this.refresh(undefined, search);
    },

    checkVisualLevel(samplingPoint: SamplingPoint) {
      this.$router.push({
        path: `samplingPoints/gallery`,
        query: {
          point: samplingPoint.id,
        },
      });
    },
    generateRoute(samplingPoint: any) {
      const container = samplingPoint.container;

      if (
        container?.id &&
        this.$route.path.includes("support") &&
        !this.$route.path.includes("samplingPoints/")
      ) {
        return {
          path: `/support/samplingPoints/${container.id}`,
          query: { samplingPoint: samplingPoint.id },
        };
      } else if (container?.id && this.detailRouterName) {
        return {
          name: this.detailRouterName,
          params: { containerid: container.id },
        };
      } else {
        return {
          path: `/samplingPoints/samplingPoints/${samplingPoint.name}`,
        };
      }
    },
  },

  watch: {
    samplingPointFirst: async function () {
      this.samplingPoints = this.samplingPointFirst;
    },
  },
});
